// extracted by mini-css-extract-plugin
export default {"page":"page__f4416ccc","header":"header__f4416ccc","tab":"tab__f4416ccc","content":"content__f4416ccc"};